import {
  useCopyProtocolQALogMutation,
  useCreateProtocolQALogMutation,
  useLazyGetProtocolQALogBasedOnDateRangeQuery,
  useLazyGetProtocolQALogQuery
} from 'src/services/protocolQALogs';

export const useProtocolQALog = () => {
  const [
    getProtocolQALogData,
    {
      data: protocolQALogData,
      error: protocolQALogDataError,
      isError: protocolQALogDataIsError,
      isLoading: protocolQALogDataIsLoading,
      isSuccess: protocolQALogDataIsSuccess
    }
  ] = useLazyGetProtocolQALogQuery();

  const [
    createProtocolQA,
    {
      data: createProtocolQAData,
      error: createProtocolQAError,
      isError: createProtocolQAIsError,
      isLoading: createProtocolQAIsLoading,
      isSuccess: createProtocolQAIsSuccess
    }
  ] = useCreateProtocolQALogMutation();

  const [
    copyProtocolQA,
    {
      data: copyProtocolQAData,
      error: copyProtocolQAError,
      isError: copyProtocolQAIsError,
      isLoading: copyProtocolQAIsLoading,
      isSuccess: copyProtocolQAIsSuccess
    }
  ] = useCopyProtocolQALogMutation();
  const [
    getProtocolQALogBasedOnDateRange,
    {
      data: protocolQALogBasedOnDateRangeData,
      error: protocolQALogBasedOnDateRangeError,
      isError: protocolQALogBasedOnDateRangeIsError,
      isLoading: protocolQALogBasedOnDateRangeIsLoading,
      isSuccess: protocolQALogBasedOnDateRangeIsSuccess
    }
  ] = useLazyGetProtocolQALogBasedOnDateRangeQuery();

  return {
    protocolQALogData,
    protocolQALogDataError,
    protocolQALogDataIsError,
    protocolQALogDataIsLoading,
    protocolQALogDataIsSuccess,
    getProtocolQALogData,
    createProtocolQAData,
    createProtocolQAError,
    createProtocolQAIsError,
    createProtocolQAIsLoading,
    createProtocolQAIsSuccess,
    createProtocolQA,
    copyProtocolQAData,
    copyProtocolQAError,
    copyProtocolQAIsError,
    copyProtocolQAIsLoading,
    copyProtocolQAIsSuccess,
    copyProtocolQA,
    getProtocolQALogBasedOnDateRange,
    protocolQALogBasedOnDateRangeData,
    protocolQALogBasedOnDateRangeError,
    protocolQALogBasedOnDateRangeIsError,
    protocolQALogBasedOnDateRangeIsLoading,
    protocolQALogBasedOnDateRangeIsSuccess
  };
};
